module.exports = __webpack_public_path__ + "img/group3Img.5b544f16.png";